import { Controller } from "@hotwired/stimulus"

// Tabs controller for switching between tab panels
// Usage:
//   <div data-controller="tabs">
//     <button data-tabs-target="tab" data-tab-id="tab1" data-action="click->tabs#switch">Tab 1</button>
//     <button data-tabs-target="tab" data-tab-id="tab2" data-action="click->tabs#switch">Tab 2</button>
//     <div data-tabs-target="panel" data-tab-id="tab1">Panel 1</div>
//     <div data-tabs-target="panel" data-tab-id="tab2" class="hidden">Panel 2</div>
//   </div>

export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]
  static values = {
    defaultTab: { type: String, default: "" }
  }

  connect() {
    // Set initial active tab if not already set
    const activeTab = this.tabTargets.find(tab =>
      tab.classList.contains("border-red-500") ||
      tab.classList.contains(this.activeClasses?.[0])
    )

    if (!activeTab && this.tabTargets.length > 0) {
      this.activateTab(this.tabTargets[0])
    }
  }

  switch(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    this.activateTab(clickedTab)
  }

  activateTab(selectedTab) {
    const tabId = selectedTab.dataset.tabId

    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab === selectedTab) {
        tab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
        tab.classList.add("border-red-500", "text-red-600")
      } else {
        tab.classList.remove("border-red-500", "text-red-600")
        tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
      }
    })

    // Show/hide panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabId === tabId) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
